export default __webpack_public_path__ + "static/media/annex_iv_assessment.aec0cc2f.png";